import { render, staticRenderFns } from "./ManagerReview.vue?vue&type=template&id=3473eac7&"
import script from "./ManagerReview.vue?vue&type=script&lang=js&"
export * from "./ManagerReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports